import { PerformanceTab } from 'model/FundDetails';
import { useSelector } from 'react-redux';
import { getAvailableTabs } from '@/store/fundDetails';
import AnnualizedTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedTable';
import CumulativeTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeTable';
import AnnualizedDailyTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/AnnualizedDailyTable';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import CumulativeDailyTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeDailyTable';
import FundDetailsPerformanceDisclaimer from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPerformanceDisclaimer';

const FundDetailsThaiPerformanceTab = ({ title }) => {
  const availablePerformanceTabs: PerformanceTab = useSelector(getAvailableTabs)?.performanceTab;

  const ThaiPerformanceTabContent = () => {
    return (
      <FundDetailsTabRow fullWidth>
        {availablePerformanceTabs.thaiCumulativeDailyTable && (
          <CumulativeDailyTable className="mt-8" />
        )}
        {availablePerformanceTabs.thaiAnnualizedDailyTable && (
          <AnnualizedDailyTable className="mt-8" />
        )}
        {availablePerformanceTabs.thaiCumulativeTable && <CumulativeTable className="mt-8" />}
        {availablePerformanceTabs.thaiAnnualizedTable && <AnnualizedTable className="mt-8" />}
      </FundDetailsTabRow>
    );
  };

  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow>
        <h2>{title}</h2>
      </FundDetailsTabRow>

      <ThaiPerformanceTabContent />

      <FundDetailsPerformanceDisclaimer isThai className="mt-8" />
    </section>
  );
};

export default FundDetailsThaiPerformanceTab;
